import { useEffect } from "react";
import { useNavigate } from "react-router";
import { all_routes } from "./all_routes";
const routes = all_routes;

const Protected_route = (props) =>{
    const { Component } = props;
    const navigate = useNavigate();

        const token = localStorage.getItem("LoginToken");

        useEffect(()=>{
            if(!token){
                navigate(routes.login);
            }
        },[])
        return(
            <>
                <Component />
            </>
        )

}

export default Protected_route;